'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mplTokenMetadata = require('@metaplex-foundation/mpl-token-metadata');
var errors = require('./errors.cjs');
var SdkError = require('../../errors/SdkError.cjs');

const tokenDelegateRoleMap = {
  StandardV1: mplTokenMetadata.TokenDelegateRole.Standard,
  TransferV1: mplTokenMetadata.TokenDelegateRole.Transfer,
  LockedTransferV1: mplTokenMetadata.TokenDelegateRole.LockedTransfer,
  SaleV1: mplTokenMetadata.TokenDelegateRole.Sale,
  UtilityV1: mplTokenMetadata.TokenDelegateRole.Utility,
  StakingV1: mplTokenMetadata.TokenDelegateRole.Staking
};
const metadataDelegateRoleMap = {
  // AuthorityItemV1: MetadataDelegateRole.AuthorityItem,
  CollectionV1: mplTokenMetadata.MetadataDelegateRole.Collection,
  // UseV1: MetadataDelegateRole.Use,
  DataV1: mplTokenMetadata.MetadataDelegateRole.Data,
  ProgrammableConfigV1: mplTokenMetadata.MetadataDelegateRole.ProgrammableConfig
};
const metadataDelegateSeedMap = {
  [mplTokenMetadata.MetadataDelegateRole.AuthorityItem]: 'authority_item_delegate',
  [mplTokenMetadata.MetadataDelegateRole.Collection]: 'collection_delegate',
  [mplTokenMetadata.MetadataDelegateRole.Use]: 'use_delegate',
  [mplTokenMetadata.MetadataDelegateRole.Data]: 'data_delegate',
  [mplTokenMetadata.MetadataDelegateRole.ProgrammableConfig]: 'programmable_config_delegate',
  [mplTokenMetadata.MetadataDelegateRole.DataItem]: 'data_item_delegate',
  [mplTokenMetadata.MetadataDelegateRole.CollectionItem]: 'collection_item_delegate',
  [mplTokenMetadata.MetadataDelegateRole.ProgrammableConfigItem]: 'prog_config_item_delegate'
};
const delegateCustomDataMap = {
  // Metadata.
  // AuthorityItemV1: false,
  CollectionV1: false,
  // UseV1: false,
  DataV1: false,
  ProgrammableConfigV1: false,
  // Token
  StandardV1: true,
  TransferV1: true,
  SaleV1: true,
  UtilityV1: true,
  StakingV1: true,
  LockedTransferV1: true
};
const getTokenDelegateRole = type => {
  const role = tokenDelegateRoleMap[type];
  if (!role) throw new SdkError.UnreachableCaseError(type);
  return role;
};
const getMetadataDelegateRole = type => {
  const role = metadataDelegateRoleMap[type];
  if (!role) throw new SdkError.UnreachableCaseError(type);
  return role;
};
const getMetadataDelegateRoleSeed = type => {
  return metadataDelegateSeedMap[getMetadataDelegateRole(type)];
};
const getDefaultDelegateArgs = type => {
  const hasCustomData = delegateCustomDataMap[type];
  if (hasCustomData === undefined) throw new SdkError.UnreachableCaseError(type);
  if (hasCustomData) throw new errors.DelegateRoleRequiredDataError(type);
  return {
    __kind: type
  };
};

exports.getDefaultDelegateArgs = getDefaultDelegateArgs;
exports.getMetadataDelegateRole = getMetadataDelegateRole;
exports.getMetadataDelegateRoleSeed = getMetadataDelegateRoleSeed;
exports.getTokenDelegateRole = getTokenDelegateRole;
//# sourceMappingURL=DelegateType.cjs.map
